module.exports = __webpack_public_path__ + "img/police.be5030ca.webp";